import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import gql from 'graphql-tag';
import graphql from "react-apollo/graphql";
// import { CSSTransitionGroup } from 'react-transition-group'
import {Link, Switch, withRouter} from "react-router-dom";
import {Route} from "react-router";
import ContentWithData from './components/Content'


const appQuery = gql`
query {
    count
    isLogged
    content {
        id,
        title, 
        text
    }
}
`;


const contentListQuery = gql`
query {
    contents(limit: 5) {
        id,
        title, 
        text
    }
}
`;


const ContentList = ({ data: {loading, error, contents }}) => {
    if (loading) {
        return <p>Loading ...</p>;
    }
    if (error) {
        return <p>{error.message}</p>;
    }
    return <ul>
        { contents.map( ch => <li key={ch.id}><Link to={'/view/'+ch.id}>{ch.id}</Link></li> ) }
    </ul>;
};


const ContentListWithData = graphql(contentListQuery)(ContentList);


class App extends Component {

    goToRandom(){
        const {loading, count } = this.props.data;
        if (!loading){
            const rand = Math.floor(Math.random() * count)  + 1;
            this.props.history.push('/view/' + rand)
        }

    }
    render() {
        const {loading, error, isLogged, content} = this.props.data;
        let login_button_url = '/accounts/login';
        let login_view = <li><a href={login_button_url}>login</a></li>;
        let icon = 'person';
        if (isLogged){
            login_button_url = "/accounts/logout";
            login_view = <li><a href={login_button_url}>logout</a></li>;
            icon = 'exit_to_app';
        }
        return (
            <div className="App">
                <header className="App-header">
                    <a className="btn-floating waves-effect waves-light" id="login_logout_button" href={login_button_url}>
                        <i className="material-icons">{icon}</i>
                    </a>
                    <img src={logo} className="App-logo" alt="logo" onClick={()=> this.goToRandom()}/>
                </header>

                {/*<nav>*/}
                    {/*<div className="nav-wrapper">*/}
                        {/*<a href="#" className="brand-logo">Logo</a>*/}
                        {/*<ul id="nav-mobile" className="right hide-on-med-and-down">*/}
                            {/*{login_view}*/}
                        {/*</ul>*/}
                    {/*</div>*/}
                {/*</nav>*/}

                <div className="container">
                    <Switch>
                        <Route exact path='/' component={()=> <p className="flow-text" >{!loading?<Link to={`/view/${content.id}`}>Перейти к следующему</Link>:null}</p>} />
                        <Route path='/view/:contentId' render={props => <ContentWithData {...props} isLogged={isLogged}/>} />
                    </Switch>
                </div>
            </div>
        );
    }
}

const AppWithData = graphql(appQuery)(withRouter(App));

export { AppWithData };



// WEBPACK FOOTER //
// ./src/App.js